import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk'
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import * as firebase from 'firebase';
import { reactReduxFirebase, firebaseStateReducer } from 'react-redux-firebase';
import { userIsAuthenticatedRedir, userIsNotAuthenticatedRedir } from './components/auth';
import { toast } from 'react-toastify';
import get from 'lodash.get';
import 'babel-polyfill';
import { fetchData } from './actions';
import local from './reducers';
import AppComponent from './App';
import LoginComponent from './components/Login';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './index.css';
import config from './config.json';

const environment = config.environments[process.env.REACT_APP_ENVIRONMENT];

const firebaseConfig = {
  apiKey: environment.FIREBASE_API_KEY,
  authDomain: environment.FIREBASE_AUTH_DOMAIN,
  databaseURL: environment.FIREBASE_DATABASE_URL,
};

firebase.initializeApp(firebaseConfig);

const rootReducer = combineReducers({
  firebase: firebaseStateReducer,
  local,
});

const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, { userProfile: 'users' }),
)(createStore);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store;

// Fetch contents of data file only if configured to do so
if (config.data === 'file') {
  store = createStore(combineReducers({ local }), composeEnhancers(applyMiddleware(thunkMiddleware)));
  store.dispatch(fetchData());
} else {
  store = createStoreWithFirebase(rootReducer, composeEnhancers(applyMiddleware(thunkMiddleware)));
}

let lastTimestamp;
let lastDashboard;

//** Display toast if timestamp exists and has increased since last store update */
if (config.data !== 'file') {
  store.subscribe(() => {
    const state = store.getState();
    const timestamp = get(state.firebase.data, `${state.local.source}.Source.TimeStamp`);
    const username = get(state.firebase.data, `${state.local.source}.Source.UserName`);

    if (timestamp !== undefined) {
      if (timestamp > lastTimestamp && state.local.dashboard === lastDashboard) {
        toast.info(<p>{username} just updated this dashboard</p>);
      }

      lastTimestamp = timestamp;
      lastDashboard = state.local.dashboard;
    }
  })
}

let Login = null;
let App = null;

/** Wrap top-level components with redirects if using authentication */
if (environment.ENABLE_AUTH) {
  Login = userIsNotAuthenticatedRedir(LoginComponent);
  App = userIsAuthenticatedRedir(AppComponent);
} else {
  Login = LoginComponent;
  App = AppComponent;
}

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <div>
        <Route exact path="/" render={() => <Redirect to={"/dashboard/" + environment.dashboards[0]} />} />
        <Route path="/login" component={Login} />
        <Route path="/dashboard/:dashboardId" render={(rest) => (
          <App {...rest} />
        )} />
      </div>
    </Router>
  </Provider>,
  document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js